import uiRouter from '@uirouter/angularjs';
import ngTranslate from 'angular-translate';
import assign from 'lodash/assign';

import template from './deleteModal.html';

export const DeleteModalModule = angular
    .module('app.components.modals.deleteModal', [
        uiRouter,
        'ngMaterial',
        ngTranslate
    ]).component('deleteModal', {
        template,
        bindings: {
            itemCount: '<',
            itemType: '<',
            isDetail: '<',
            productLength: '<',
            subCategoryLength: '<',
            menuCount: '<'
        },
        controller: class DeleteModalController {
            constructor(
                $scope,
                $mdDialog,
                $translate,
                $state,
                $mdMenu
            ) {
                'ngInject';

                assign(this, {
                    translateData: {},
                    gtmid: '',
                    warnings: [],

                    $scope,
                    $mdDialog,
                    $translate,
                    $state,
                    $mdMenu
                });
            }

            $onInit() {
                this.gtmid = `admin_${this.$state.current.name}_deleteModal`;
                this.setWarnings();
                this.getTranslation(this.itemType)
                    .then((type) => {
                        this.translateData = {
                            COUNT: this.itemCount,
                            TYPE: type
                        };
                    });
                this.$mdMenu.hide();
            }

            setWarnings() {
                if (this.productLength) {
                    this.warnings.push({
                        text: (this.productLength > 1) ?
                            'CATEGORY.PRODUCTSWARNING' : 'CATEGORY.PRODUCTWARNING',
                        options: { COUNT: this.productLength }
                    });
                }

                if (this.subCategoryLength) {
                    this.warnings.push({
                        text: 'CATEGORY.SUBCATEGORYWARNING',
                        options: { COUNT: this.subCategoryLength }
                    });
                }

                if (this.menuCount) {
                    this.warnings.push({
                        text: (this.menuCount > 1) ? 'CATEGORY.MENUSWARNING' : 'CATEGORY.MENUWARNING',
                        options: { COUNT: this.menuCount }
                    });
                }
            }

            getTranslation(iType) {
                let type = this.itemCount > 1 ? `${iType}.PLURAL` : `${iType}.SINGLE`;
                return this.$translate(type);
            }

            confirmDelete() {
                this.$mdDialog.hide();
            }

            cancelDelete() {
                this.$mdDialog.cancel('cancel');
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/modals/deleteModal/deleteModal.controller.js